import type { UseIntl } from '../../../../types';
import { VALID_USERNAME_REGEX } from '../constants';
import messages from '../messages';

export const usernameRegex = new RegExp(VALID_USERNAME_REGEX, 'i');

/**
 * It validates the username field value
 */
const validateUsername = (intl: UseIntl, value?: string): string => {
  let fieldError = '';
  if (!value || value.length <= 1 || value.length > 30) {
    fieldError = intl.formatMessage(messages.validationUsernameEmptyError);
  } else if (!usernameRegex.test(value)) {
    fieldError = intl.formatMessage(messages.validationUsernameFormatError);
  }
  return fieldError;
};

export default validateUsername;
